<template>
  <div class="wrap">
    <img :src="bgpic" width="100%">
    <div class="table_num text-center color-brown" v-if="tableNO">桌号：{{tableNO}}</div>
    <img class="white_bg" src="../../assets/image/whitebg-01.svg" width="100%"/>

    <div class=" bottom color_white">
      <div class="root-width25 text-center root_bottom_item" @click="clickReg(actObj.vipurl)" v-if="actObj.isvip>=0">
        <img v-if="actObj.isvip==0" src="../../assets/image/hyzc-01.svg" width="80"/>
        <img v-if="actObj.isvip==1" src="../../assets/image/wdkq-01.svg" width="80"/>
      </div>
      <!--我要点菜-->
      <div class="root-width25 text-center relation root_bottom_item" @click.stop="clickOrder()">
        <img src="../../assets/image/wydc-01.svg" width="80"/>
      </div>
      <!--已结账单-->
      <div class="root-width25 text-center relation root_bottom_item" @click.stop="clickPayed()">
        <img src="../../assets/image/yjzd-01.svg" width="80"/>
      </div>
      <!--团购券抢购-->
      <div class="root-width25 text-center relation root_bottom_item" v-if="actObj.actnum>0" @click.stop="clickCoupon(actObj.acturl)">
        <img src="../../assets/image/tgqqg-01.svg" width="80"/>
        <div class="bottom_num color-white font-0-8">{{actObj.actnum}}</div>
      </div>
    </div>
  </div>
</template>
<script>
  import ServiceUtils from "../../service/ServiceUtils";
  import ServiceHttp from "../../service/ServiceHttp";
  import ServiceDialog from "../../service/ServiceDialog";
  import bgerr from '../../assets/image/bg.jpg'
  import math from 'mathjs'
  import {Toast} from  'vant'
  let actObj = { actnum:0,acturl:'',isvip:0,vipurl:''};
  let isAlert = false;
  export default {
    name: "init",
    data(){
      return{
        // bgerr:bgerr,
        bgpic:bgerr,
        tableNO:'',                                                              //桌号
        actObj:{ actnum:0,acturl:'',isvip:0,vipurl:''}
      }
    },
    methods:{
      /**
       * 检查用户活动，
       * 非会员检查随客营销，开卡有礼，随客发券
       * 会员时：检查到店客人团购
       */
      checkMemeberCoupon:function(){
        this.actObj =actObj;
        if(isAlert)return;
        isAlert=true;
        if(document.readyState == 'complete'){
          M_CheckMemberCoupon.checkMemberCoupon({
            domain:ServiceUtils.config.domain,
            sellerid: ServiceUtils.config.sellerId,
            storeid:ServiceUtils.config.storeId,
            callback: (res)=> {
              console.log("会员活动插件返回this.actObj：：",res);
              actObj = res;
              this.actObj = {
                actnum :res.actnum,
                acturl :res.acturl,
                isvip  :res.isvip,
                vipurl :res.vipurl
              };
            }
          });

        }else {

          window.onload=()=>{
            M_CheckMemberCoupon.checkMemberCoupon({
              domain:ServiceUtils.config.domain,
              sellerid: ServiceUtils.config.sellerId,
              storeid:ServiceUtils.config.storeId,
              callback: (res)=> {
                console.log("会员活动插件返回this.actObj：：",res);
                actObj = res;
                this.actObj = {
                  actnum :res.actnum,
                  acturl :res.acturl,
                  isvip  :res.isvip,
                  vipurl :res.vipurl
                };
              }
            });
          }
        }
      },
      /**
       * 点击已结账单
       * */
      clickPayed(){
        let url = '/bill/{0}'.format(ServiceUtils.config.sellerId);
        this.$router.replace({path:url});
      },

      /**
       * 新会员注册
       * */
      clickReg(url){
        if(url){
          window.location.href = url;
        }else{
          window.location.href = ServiceUtils.getVipRegisterUrl();
        }
      },
      /**
       *
       * 团购券抢购
       *
       * */
      clickCoupon(url){
        if(url){
          window.location.href = url;
        }
      },
      /**
       * 点菜
       */
      clickOrder(){
        let url = '/orderv2/{0}/{1}/{2}/{3}'.format(ServiceUtils.config.sellerId,ServiceUtils.config.storeId,
          ServiceUtils.config.orderType,ServiceUtils.config.tableNo || 'no');
        this.$router.replace({path:url});
      },
      /**
       * 获取门店名称
       * */
      getStroeNmae(){
        ServiceHttp.getStroeNmae((res)=>{
          console.log("门店名称：：",res);
          if(res){
            ServiceUtils.changeTitle(res.name);
          }
        })
      },
      getUnPayOrder(){
        ServiceHttp.getUnPayOrder();
      },
      getRecommendAtionSatate(){ //获取推荐菜数据
        ServiceHttp.getRecommendAtionSatate()
      },
      /**
       * 获取背景图片
       */
      getBgPic() {
        Toast.loading({duration:0, forbidClick: true, message:'菜品装填中'});
        ServiceHttp.getBgPic((res)=> {
          if(res){
            if(res.picurl){
              this.bgpic = ServiceUtils.getCdnDomain()+ res.picurl+"?v="+ServiceUtils.getSystemCfg().PicVersion;
            }
            ServiceUtils.setOpenSmartSort(res.openSmartSort);
          }else {
            ServiceUtils.setOpenSmartSort(0);
          }
          if(res && res.openSchemaMenu === 1){
            this.getLoadData(true);//获取时效菜谱
          }else {
            this.getLoadData();
          }
        });
      },
      /**
       * 初始方法
       * */
      getLoadData(openSchemaMenu){
        /**
         * 获取图片数据
         * */
        ServiceHttp.getPicData(openSchemaMenu,()=>{
          //获取必点项目
          ServiceHttp.getBidianMenu(bidianMenuItems=>{
              ServiceUtils.bidianMenu = bidianMenuItems;
              //获取可点菜列表
            ServiceHttp.getMenufilter(()=>{
              /**
               * 获取原始菜单数据
               * */
              ServiceHttp.getOriginMenuData(()=>{
                ServiceUtils.sortPicMode(ServiceUtils.getOpenSmartSort()) ;
                this.loadSaleOutData();
              });
            })

          });

          /**
           * 获取配菜数据
           */
          ServiceHttp.getSideDish();
        });
      },
      /**
       * 获取已点单
       * */
      getPreFood(){
        if(ServiceUtils.config.menuClass == 1) return ;
        let saleOutTmp = {} ;
        ServiceUtils.saleout.forEach((item)=>{
          saleOutTmp[item] = true;
        });
        ServiceHttp.getPreFood((res)=>{
          console.log('获取已点单:',res);
          res.data.forEach((type)=> {
            type.menuItem.forEach((item) => {
              item.uid = undefined;
              item.orderid = undefined;
              item.sgid = undefined;
              item.menuItem.forEach((order)=>{
                order.uid = undefined;
                order.orderid = undefined;
                order.price= math.round(order.price+"",2);
                order.memberprice= "0";
                order.memberNo = "";
                order.sgid = undefined
              });
              if (saleOutTmp[item.code] !=item.code) {

                if(type.isGroup == 0){
                  let types = {
                    name:type.name ||0,
                    code:type.code || '',
                    ename:type.ename || '',
                    isGroup: 0
                  };
                  let order = {
                    code: item.code,
                    name: item.name,
                    sndname: item.sndname || "",
                    price: (item.price*1,2),
                    memberprice: item.memberprice*1||0,
                    standard:item.standard || "",
                    num: item.num,
                    menuItem: item.menuItem,
                    memo: item.memo || "",
                    drink:item.drink||0
                  } ;
                  ServiceUtils.setNoSuitData(types,order)
                }else {
                  item.menuItem = item.menuItem;
                  item.menuItem = undefined;
                  console.log(item);
                  ServiceUtils.setSuitData(item);
                }



              }
            })
          }) ;
          ServiceHttp.delPreFood();
        });
      },
      /**
       * 获取沽清数据
       */
      loadSaleOutData(){
        ServiceHttp.getSaleOutData(()=>{
          Toast.clear()
          ServiceUtils.dealSaleOut();
          this.getPreFood();
        })
      }
    },
    mounted() {
      window.onerror = function () {
        Toast.clear();
      }

      let params = this.$route.params ;      //url参数
      let actionurl ='';
      ServiceUtils.config.sellerId = params.sellerId;
      ServiceUtils.config.storeId = params.storeId;
      //判断url是否带餐桌号
      if(params.orderType.indexOf('@')>0){
        let strs = params.orderType.split('@');
        ServiceUtils.config.orderType = strs[0] || 0;
        ServiceUtils.config.tableNo = strs[1] || '';
        ServiceUtils.config.isTakeTable = true;
        this.tableNO = ServiceUtils.config.tableNo;
        actionurl="/weixin/useraction/{0}/{1}/{2}/2.html".format(ServiceUtils.config.sellerId,
          ServiceUtils.config.storeId,
          ServiceUtils.config.tableNo);
      }else{
        ServiceUtils.config.orderType = params.orderType;
        actionurl="/weixin/useraction/{0}/{1}/1.html".format(ServiceUtils.config.sellerId,ServiceUtils.config.storeId);
      }
      this.tableNO = ServiceUtils.config.tableNo;
      //获取用户行为
      ServiceHttp.useraction(actionurl);
      //判断堂食与自提
      if(ServiceUtils.config.orderType==0 || ServiceUtils.config.orderType==1){ //堂食和自提用 堂食菜谱
        ServiceUtils.config.menuClass = 0;
      }else{ //用外卖菜谱
        ServiceUtils.config.menuClass = 1;
      }
      this.checkMemeberCoupon();
      this.getBgPic();
      this.getStroeNmae();
      this.getUnPayOrder();
      this.getRecommendAtionSatate();
    },
  }
</script>

<style scoped lang="scss">
  @import "../../assets/css/style";
  .white_bg{
    position: absolute;
    left: 0;
    right: 0;
    bottom: 99px;
  }
  .bottom{
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100px;
    background-color: white;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }
  .bottom_num{
    position: absolute;
    top:5px;
    right: 10px;
    width: 20px;
    height: 20px;
    background:red;
    border-radius: 10px;
    text-align: center;
    line-height: 20px;
  }
  .table_num{
    position: absolute;
    font-size: 1.2em;
    bottom: 115px;
    width: 30%;
    height: 30px;
    border-radius: 18px;
    background-color: white;
    margin: 0 35%;
    line-height: 30px;
    border: 1px solid rgba(0,0,0,0.5);
  }
  .root_bottom_item:last-child {
    margin-top: -10px;
  }
  .root_bottom_item:first-child {
    margin-top: -10px;
  }
  .root_bottom_item {
    margin-top: 5px;
  }
  .root-width25{width: 25%;}

</style>



// WEBPACK FOOTER //
// src/components/routerPages/init.vue